import InfoBoxesContainer from './InfoBoxesContainer'
export default InfoBoxesContainer
